import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this)
  }

  open() {
    this.modalTarget.hidden = false
    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this.handleKeydown)
  }

  close() {
    this.modalTarget.hidden = true
    document.body.style.overflow = ""
    document.removeEventListener("keydown", this.handleKeydown)
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) this.close()
  }

  handleKeydown(event) {
    if (event.key === "Escape") this.close()
  }
}
